module.exports = __webpack_public_path__ + "static/Check Back Card-c324c660cac422a7375634336e2da2a4.png";